<template>
  <main class="main profile-page page-inside" v-if="$parent.isAuth">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="profile-form">
            <div class="tab-list">
              <router-link to="/profile" class="item">Account</router-link>
              <router-link v-if="$parent.offerEnabled" to="/offers" class="item"
                >My Offers</router-link
              >
              <router-link to="/orders" class="item">Order history</router-link>
              <div @click="$parent.logout" class="item">Log Out</div>
            </div>
            <div class="profile-form-wrapper">
              <div class="wrapper balance-wrapper">
                <div class="title small">
                  <b>Balance</b>
                </div>
                <PriceFormatter
                  :price="formattedBalance"
                  tag="div"
                  rootClass="balance-value"
                  currencyClass="balance-value__currency"
                  imageClass="balance-value__image"
                  textClass="balance-value__text"
                  amountClass="balance-value__amount"
                />
                <div class="desc balance-rate">
                  1 {{ currencyName }} = {{ selectedCurrencyRate }}
                  {{ currencySymbol }}
                </div>
                <div class="input-container">
                  <div class="desc">Top-up amount ({{ currencyName }}):</div>
                  <input
                    type="text"
                    placeholder="Amount"
                    v-model="topUpAmount"
                    @input="allowOnlyMoney"
                  />
                </div>
                <div
                  class="desc balance-payment-preview"
                  v-if="topUpAmountIsValid"
                >
                  To pay: {{ topUpPaymentAmount }} {{ currencySymbol }}
                </div>
                <button
                  :class="['button', { disabled: !topUpAmountIsValid }]"
                  :disabled="!topUpAmountIsValid"
                  @click="openTopUpModal"
                >
                  <span>Top up</span>
                </button>
              </div>
              <div class="wrapper">
                <div class="title small">
                  <b>Personal Information</b>
                </div>
                <div>
                  <div class="input-container">
                    <div class="desc">
                      <span class="red">*</span> First name:
                    </div>
                    <input
                      type="text"
                      placeholder="First name"
                      v-model="name"
                    />
                  </div>
                  <div class="input-container">
                    <div class="desc"><span class="red">*</span> E-mail:</div>
                    <input type="email" placeholder="E-mail" v-model="email" />
                  </div>
                  <div class="input-container">
                    <div class="desc">
                      <span class="red">*</span> Last name:
                    </div>
                    <input
                      type="text"
                      placeholder="Last name"
                      v-model="surname"
                    />
                  </div>
                  <div class="input-container">
                    <div class="desc"><span class="red">*</span> Phone:</div>
                    <input type="tel" placeholder="Phone" v-model="phone" />
                  </div>
                </div>
                <button class="button" @click="updateProfileData">
                  <span>Save</span>
                </button>
                <transition name="fade">
                  <div class="desc red" v-if="profileUpdateErrorMessaage">
                    {{ profileUpdateErrorMessaage }}
                  </div>
                </transition>
                <transition name="fade">
                  <div class="desc green" v-if="profileUpdateSuccessMessaage">
                    {{ profileUpdateSuccessMessaage }}
                  </div>
                </transition>
              </div>
              <div class="wrapper">
                <div class="title small">
                  <b>Change Password</b>
                </div>
                <div class="input-container">
                  <div class="desc">
                    <span class="red">*</span> Current password:
                  </div>
                  <input
                    type="text"
                    placeholder="Current password"
                    v-model="curPass"
                  />
                </div>
                <div class="input-container long">
                  <div class="desc">
                    <span class="red">*</span> New password:
                  </div>
                  <input
                    type="text"
                    placeholder="New password"
                    v-model="newPass"
                  />
                </div>
                <div class="input-container long">
                  <div class="desc">
                    <span class="red">*</span> Confirm password:
                  </div>
                  <input
                    type="text"
                    placeholder="Confirm password"
                    v-model="repeatPass"
                  />
                </div>
                <div class="pass-rules">
                  <div class="desc bold">Password must contain:</div>
                  <div class="desc">
                    - At least 6 characters, 1 upper case letter (A-Z), 1 lower
                    case letter (a-z), 1 number (0-9)
                  </div>
                </div>
                <button class="button" @click="updatePassword">
                  <span>Save</span>
                </button>
                <transition name="fade">
                  <div class="desc red" v-if="passUpdateErrorMessaage">
                    {{ passUpdateErrorMessaage }}
                  </div>
                </transition>
                <transition name="fade">
                  <div class="desc green" v-if="passUpdateSuccessMessaage">
                    {{ passUpdateSuccessMessaage }}
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { mapGetters } from "vuex";
import PriceFormatter from "../components/PriceFormatter.vue";

export default {
  name: "Profile",
  props: [],
  components: {
    PriceFormatter,
  },
  data: function () {
    return {
      email: "",
      name: "",
      surname: "",
      phone: "",
      profileUpdateSuccessMessaage: "",
      profileUpdateErrorMessaage: "",
      curPass: "",
      newPass: "",
      repeatPass: "",
      passUpdateSuccessMessaage: "",
      passUpdateErrorMessaage: "",
      balance: 0,
      balanceFiat: 0,
      topUpAmount: "",
    };
  },
  mounted() {
    this.$http
      .get(process.env.VUE_APP_API + "user/profile", {
        params: { currency: this.currency },
      })
      .then((res) => {
        this.email = res.data.email;
        this.name = res.data.name;
        this.surname = res.data.surname;
        this.phone = res.data.phone;
        this.balance = res.data.balance || 0;
        this.balanceFiat = res.data.balance_fiat || 0;
      })
      .catch((res) => {
        if (res.response.status === 401) {
          this.$parent.openSignIn();
        }
      });
  },
  methods: {
    openOfferDetailsModal() {
      this.$emit("openOfferDetailsModal");
    },
    allowOnlyMoney() {
      this.topUpAmount = this.topUpAmount.replace(/[^0-9.,]/g, "");
      const parts = this.topUpAmount.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }
      this.topUpAmount =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
    },
    openTopUpModal() {
      if (!this.topUpAmountIsValid) return;
      this.$parent.openTopUpModal(this.topUpAmount);
    },
    updateProfileData() {
      let profileData = {
        email: this.email,
        name: this.name,
        phone: this.phone,
        surname: this.surname,
      };
      this.$http
        .put(process.env.VUE_APP_API + "user/profile", profileData)
        .then((res) => {
          if (res.data.status == "OK") {
            this.profileUpdateSuccessMessaage = "Success";
            this.$parent.refreshUserProfile();
            setTimeout(() => {
              this.profileUpdateSuccessMessaage = "";
            }, 3000);
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
          this.profileUpdateErrorMessaage = res.response.data.message;
          setTimeout(() => {
            this.profileUpdateErrorMessaage = "";
          }, 3000);
        });
    },
    updatePassword() {
      let passwordList = {
        cur_password: this.curPass,
        new_password: this.newPass,
        repeat_password: this.repeatPass,
      };
      this.$http
        .post(process.env.VUE_APP_API + "user/change-password", passwordList)
        .then((res) => {
          if (res.data.status == "OK") {
            this.passUpdateSuccessMessaage = "Success";
            (this.curPass = ""), (this.newPass = ""), (this.repeatPass = "");
            setTimeout(() => {
              this.passUpdateSuccessMessaage = "";
            }, 3000);
          }
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignIn();
          }
          this.passUpdateErrorMessaage = res.response.data.message;
          setTimeout(() => {
            this.passUpdateErrorMessaage = "";
          }, 3000);
        });
    },
  },
  computed: {
    ...mapGetters("app", [
      "internalCurrency",
      "internalCurrencyEnabled",
      "currency",
      "currencyRate",
      "currencySymbol",
    ]),
    formattedBalance() {
      const profileBalance =
        this.$parent.userProfile &&
        this.$parent.userProfile.balance !== undefined
          ? this.$parent.userProfile.balance
          : this.balance;
      return parseFloat(profileBalance || 0).toFixed(2);
    },
    topUpAmountIsValid() {
      return parseFloat(this.topUpAmount) > 0;
    },
    internalCurrencyEurRate() {
      return this.internalCurrency && this.internalCurrency.exchange_rate_eur
        ? this.internalCurrency.exchange_rate_eur
        : 1;
    },
    selectedCurrencyRate() {
      const rate = this.internalCurrencyEurRate * this.currencyRate;
      return this.formatRate(rate);
    },
    topUpPaymentAmount() {
      const amount = parseFloat(this.topUpAmount);
      if (Number.isNaN(amount)) return "0.00";

      if (!this.internalCurrencyEnabled) return this.formatMoney(amount);

      return this.formatMoney(
        amount * this.internalCurrencyEurRate * this.currencyRate,
      );
    },
    currencyName() {
      if (!this.internalCurrencyEnabled) return this.currency;
      return (
        this.internalCurrency.name || this.internalCurrency.symbol || "coin"
      );
    },
    formatRate() {
      return (value) => {
        const numericValue = parseFloat(value);
        if (Number.isNaN(numericValue)) return value;

        return numericValue.toLocaleString("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 4,
        });
      };
    },
    formatMoney() {
      return (value) => {
        const numericValue = parseFloat(value);
        if (Number.isNaN(numericValue)) return "0.00";

        return numericValue.toFixed(2);
      };
    },
  },
};
</script>

<style scoped>
.profile-form-wrapper {
  flex-wrap: wrap;
}

.balance-wrapper {
  flex: 0 0 100%;
  display: grid;
  grid-template-columns: minmax(180px, 1fr) minmax(260px, 1fr);
  align-items: end;
  column-gap: 32px;
  row-gap: 16px;
}

.balance-wrapper .title,
.balance-wrapper .balance-value,
.balance-wrapper .balance-rate {
  grid-column: 1;
}

.balance-wrapper .balance-value {
  color: #363d47;
  font-size: 34px;
  line-height: 40px;
  font-weight: 700;
  margin-bottom: 8px;
}

.balance-payment-preview {
  grid-column: 2;
  color: #96a4c4;
  margin-top: -8px;
}

.balance-wrapper .balance-value ::v-deep .balance-value__currency {
  min-width: 34px;
}

.balance-wrapper .balance-value ::v-deep .balance-value__image {
  width: 34px;
  height: 34px;
}

.balance-wrapper .balance-value ::v-deep .balance-value__text,
.balance-wrapper .balance-value ::v-deep .balance-value__amount {
  color: #000;
}

.profile-form .wrapper.balance-wrapper .balance-rate {
  text-align: center;
  color: #aab0c5;
}

.balance-wrapper .input-container,
.balance-wrapper .button {
  grid-column: 2;
}

@media screen and (max-width: 768px) {
  .balance-wrapper {
    grid-template-columns: 1fr;
  }

  .balance-wrapper .title,
  .balance-wrapper .balance-value,
  .balance-wrapper .balance-rate,
  .balance-wrapper .input-container,
  .balance-wrapper .button {
    grid-column: 1;
  }
}
</style>
